var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Account/Support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 25 0 25 25 0 25"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Account/Support",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1272,15.2254 C11.3912,15.2254 10.8482,15.7704 10.8482,16.4764 L10.8482,16.5044 C10.8482,17.2124 11.3912,17.7574 12.1272,17.7574 C12.8632,17.7574 13.4062,17.2124 13.4062,16.5044 L13.4062,16.4764 C13.4062,15.7704 12.8632,15.2254 12.1272,15.2254",
    id: "Fill-1",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4209,7.2342 C11.1259,7.2342 10.1399,7.6482 9.3609,8.2952 C9.0949,8.5162 8.9799,8.8112 8.9799,9.0892 C8.9799,9.6502 9.4489,10.1192 10.0089,10.1192 C10.2589,10.1192 10.4929,10.0162 10.6709,9.8842 C11.2009,9.4872 11.7459,9.2972 12.3779,9.2972 C13.2309,9.2972 13.7309,9.6782 13.7309,10.3412 L13.7309,10.3702 C13.7309,11.0922 13.1439,11.4882 11.8639,11.6492 C11.3909,11.7082 11.1129,12.0462 11.1849,12.5342 L11.3329,13.5322 C11.3909,13.9302 11.7009,14.2552 12.1269,14.2552 L12.2459,14.2552 C12.6719,14.2552 12.9799,13.9162 13.0399,13.5322 L13.0839,13.2692 C14.6879,12.9442 15.9819,12.1802 15.9819,10.3102 L15.9819,10.2822 C15.9819,8.3262 14.5409,7.2342 12.4209,7.2342",
    id: "Fill-3",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5037,25 C11.7797,25 11.0537,24.938 10.3307,24.81 C7.3007,24.275 4.5827,22.649 2.6777,20.232 C0.7737,17.812 -0.1683,14.787 0.0247,11.715 C0.2177,8.642 1.5317,5.76 3.7237,3.599 C5.9147,1.438 8.8157,0.166 11.8907,0.014 C14.9627,-0.132 17.9757,0.85 20.3677,2.787 C20.7967,3.134 20.8627,3.764 20.5147,4.194 C20.1677,4.622 19.5397,4.689 19.1077,4.341 C17.0987,2.713 14.5787,1.881 11.9877,2.012 C9.4057,2.139 6.9687,3.209 5.1277,5.023 C3.2867,6.838 2.1827,9.259 2.0207,11.84 C1.8587,14.421 2.6497,16.961 4.2497,18.994 C5.8487,21.025 8.1327,22.392 10.6787,22.841 C13.2257,23.288 15.8387,22.784 18.0347,21.422 C20.2317,20.059 21.8437,17.942 22.5737,15.461 C23.3017,12.981 23.0927,10.328 21.9827,7.992 C21.7457,7.494 21.9587,6.897 22.4577,6.66 C22.9547,6.423 23.5527,6.635 23.7897,7.134 C25.1107,9.914 25.3597,13.073 24.4917,16.026 C23.6237,18.979 21.7047,21.498 19.0897,23.121 C17.0977,24.357 14.8167,25 12.5037,25",
    id: "Fill-5",
    fill: "inherit"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFaq);
export default __webpack_public_path__ + "static/media/dashboard_faq.bc58086d7ff04fd8582f351d73b710f7.svg";
export { ForwardRef as ReactComponent };